import { Icon, Button, Input, Divider } from 'semantic-ui-react';

/**
 * Controls for the currently selected person image
 * Includes name editing, set default, crop, remove from canvas
 */
const SelectedImageControls = ({
    activePersonImage,
    editingName,
    tempName,
    setTempName,
    onSaveName,
    onStartEditName,
    onSetDefault,
    onOpenEditor,
    onRemovePersonImage,
    onRemoveBackgroundClick,
    onToggleBackground,
    isOperationInProgress,
    hasCredits,
    creditBalance,
    daysUntilReset
}) => {
    return (
        <div className="selected-image-controls">
            {/* Action Buttons - Single row */}
            <div className="action-buttons-row" style={{
                display: 'flex',
                gap: '8px',
                marginBottom: '12px'
            }}>
                <Button
                    style={{
                        backgroundColor: '#f2c94c',
                        color: '#000',
                        flex: 1,
                        margin: 0,
                        padding: '10px 8px',
                        fontSize: '12px'
                    }}
                    onClick={onSetDefault}
                    disabled={!activePersonImage || activePersonImage?.isDefault || isOperationInProgress}
                >
                    <Icon name={activePersonImage?.isDefault ? 'star' : 'star outline'} />
                    {activePersonImage?.isDefault ? 'Default' : 'Default'}
                </Button>

                <Button
                    color="blue"
                    basic
                    onClick={onOpenEditor}
                    disabled={!activePersonImage || isOperationInProgress}
                    style={{
                        flex: 1,
                        margin: 0,
                        padding: '10px 8px',
                        fontSize: '12px'
                    }}
                >
                    <Icon name="crop" />
                    Crop
                </Button>

                <Button
                    color="red"
                    basic
                    onClick={onRemovePersonImage}
                    disabled={!activePersonImage || isOperationInProgress}
                    style={{
                        flex: 1,
                        margin: 0,
                        padding: '10px 8px',
                        fontSize: '12px'
                    }}
                >
                    <Icon name="remove" />
                    Remove
                </Button>
            </div>

            {/* Name Input Section */}
            <div className="name-input-section">
                {editingName ? (
                    <Input
                        fluid
                        placeholder="Enter image name"
                        value={tempName}
                        onChange={(e) => setTempName(e.target.value)}
                        action={{
                            color: 'teal',
                            icon: 'check',
                            onClick: onSaveName,
                            disabled: isOperationInProgress
                        }}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter' && !isOperationInProgress) {
                                onSaveName();
                            }
                        }}
                        disabled={isOperationInProgress}
                        size="small"
                    />
                ) : (
                    <div
                        className="display-name-section"
                        onClick={onStartEditName}
                        style={{
                            padding: '10px 14px',
                            fontSize: '13px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}
                    >
                        <Icon name="pencil" size="small" style={{ opacity: 0.5, margin: 0 }} />
                        <span className="display-name" style={{ color: '#888' }}>
                            {activePersonImage?.displayName || 'Click to add name'}
                        </span>
                    </div>
                )}
            </div>

            <Divider style={{ margin: '0' }} />
        </div>
    );
};

export default SelectedImageControls;
